import { render } from "./Footer.vue?vue&type=template&id=3b0032ed&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=3b0032ed&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3b0032ed"

export default script